module.exports = __webpack_public_path__ + "img/cut_xl1.eb3891bf.jpg";